import React from 'react';
import {Link} from 'react-router-dom';

import {LessonApi} from 'services/network/api';
import {CardContainer, Notification, Loading} from 'components/common/uiKit';
import {NoRecord} from 'components/common/app';

class LessonsTab extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            courseId: props.courseId,
            data: undefined,
            loading: true
        };
    }

    componentDidMount() {
        const res = this.checkCourseId();
        if (!res) {
            Notification('error', 'WrongData');
            return;
        }

        this.loadData();
    }

    checkCourseId() {
        const {courseId} = this.props;
        if (courseId) {
            this.setState({courseId});
            return true;
        }
        return false;
    }

    loadData() {
        //Todo: use loading
        const {courseId} = this.state;
        LessonApi.GetByCourseId(courseId)
            .then(res => {
                if (res && res.status == 200) {
                    this.setState({data: res.data});
                }
            }).finally(() => {
            this.setState({loading: false});
        })
    }

    render() {
        const {data, loading} = this.state;

        if (loading)
            return <Loading/>;

        if (!data || !data.courseId || data.lessons && data.lessons.length == 0) {
            return (
                <NoRecord message='CourseLesson'/>
            );
        }

        const {description, lessons} = data;
        //show data
        return (
            <CardContainer>
                <p>{description}</p>

                <div className="list-group list-custom-small">
                    {lessons.map((item, index) => {
                        const number = index + 1;
                        const {title} = item;
                        return (
                            <Link to={`lesson?lessonId=${item.id}`}>
                                <i className='rounded-sm shadow-xl bg-primary' style={{fontStyle: 'normal'}}>
                                    {number}
                                </i>
                                <span className='float-right'>
                                    {title}
                                </span>
                                <i className="fa fa-angle-left"></i>
                            </Link>
                        );
                    })}
                </div>
            </CardContainer>
        );
    }
}

export default LessonsTab;